module.exports = __webpack_public_path__ + "img/print.b962d3e6.svg";